import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PhxRadioSelectComponent } from './phx-radio-select.component';

@NgModule({
  declarations: [
    PhxRadioSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    PhxRadioSelectComponent,
  ]
})
export class PhxRadioSelectModule { }
